import { ConflictError } from './ConflictError';

export interface MissingScoreDto {
  details: string;
  dancer: {
    id: string;
    username: string;
    bib: number;
  };
  evaluator: {
    id: string;
    username: string;
    role: 'Judge' | 'Dancer';
    bib?: number;
  };
}

export class ScoringIncompleteError extends ConflictError {
  constructor(
    message: string,
    public override readonly errors: MissingScoreDto[] = [],
  ) {
    super(message, errors);
    this.name = 'ScoringIncompleteError';
  }
}
